"use strict";

var language = {
  /**
   * Czech language data
   */
  cs: {
    'langHeaderBackButton': 'Zpět',
    'langHeaderHeadline1': 'Přehled aktuálních nabídek Canon -<br> získejte peníze, dárek nebo voucher za nákup produktů Canon',
    'langHeaderHeadline2': 'Vyberte si skupinu a&nbsp;následně produkt. Po výběru se vám zobrazí aktuální promonabídka včetně termínu a&nbsp;odměny.',
    'langHeaderOptionGroup': 'Skupina',
    'langHeaderOptionProduct': 'Produkt',
    'langHeaderButtonSelect': 'Vybrat',
    'langMainTableProduct': 'Produkt',
    'langMainTableCampaign': 'Akce',
    'langMainTableTerms': 'Podmínky',
    'langMainTableBonus': 'Bonus',
    'langMainEmptyProduct': 'Nebyl vybrán žádný produkt.',
    'langMainAddProduct': 'Přidat produkt',
    'langMainTotalDiscount': '*Celková cena bonusu: <strong><span>0</span>&nbsp;Kč</strong>',
    'langMainInfo': '*Výpočet je pouze orientační celková suma zpětných bonusů za vybrané produkty. Aktuální výše cashbacků a&nbsp;dárků jsou uvedeny na registračních stránkách u&nbsp;daných akcí. <br/>V případě, že je vybráno více objektivů, vrací se Cashback u&nbsp;Virtualkitu pouze na jeden objektiv a&nbsp;to nejvyšší částka. Specifikace akce podléhají změnám bez předchozího upozornění. Výpočtové chyby jsou vyhrazeny.',
    'langMainDiscountCondition': 'Virtual Kit neplatí pro objektivy, které byly zakoupeny v&nbsp;kitu',
    'langMainCampaings': 'Aktuální akce',
    'langFooterCopyright': '&copy; 2019 - 2020 Canon CZ, s.r.o., všechna práva vyhrazena.'
  },

  /**
   * Slovakia language data
   */
  sk: {
    'langHeaderBackButton': 'Späť',
    'langHeaderHeadline1': 'Prehľad aktuálnych ponúk Canon -<br> získajte peniaze alebo darček za nákup produktov Canon',
    'langHeaderHeadline2': 'Vyberte si skupinu a&nbsp;následne produkt. Po výbere sa vám zobrazí aktuálna promoakcia vrátane termínu a&nbsp;odmeny.',
    'langHeaderOptionGroup': 'Skupina',
    'langHeaderOptionProduct': 'Produkt',
    'langHeaderButtonSelect': 'Vybrať',
    'langMainTableProduct': 'Produkt',
    'langMainTableCampaign': 'Akcia',
    'langMainTableTerms': 'Podmienky',
    'langMainTableBonus': 'Bonus',
    'langMainEmptyProduct': 'Nebol vybraný žiadny produkt.',
    'langMainAddProduct': 'Pridať produkt',
    'langMainTotalDiscount': '*Celková cena bonusu: <strong><span>0</span>&nbsp;EUR</strong>',
    'langMainInfo': '*Výpočet je len orientačná celková suma spätných bonusov za vybrané produkty. Aktuálna výška Cashbackov a&nbsp;darčekov sú uvedené na registračných stránkach u&nbsp;daných akcií. <br/>V prípade, že je vybrané viac objektívov, vracia sa Cashback u&nbsp;Virtualkitu iba na jeden objektív a&nbsp;to najvyššia suma. Špecifikácie akcie podliehajú zmenám bez predchádzajúceho upozornenia. Výpočtové chyby sú vyhradené.',
    'langMainDiscountCondition': 'Virtual Kit neplatí pre objektívy, ktoré boli zakúpené v&nbsp;kitu',
    'langMainCampaings': 'Aktuálne akcie',
    'langFooterCopyright': '&copy; 2019 - 2020 Canon Slovakia s.r.o., všetky práva vyhradené.'
  }
};